import React from 'react';
import { PageTitle } from '../../../common/components/page-title';
import { DocsLayout } from '../../common/components/layout/docs-layout';
import { RoutesList } from '../../common/components/routes-list';
import { POST_ROUTES } from '../configs/routes';

export const DocsPostPage = () => (
	<React.Fragment>
		<PageTitle
			title="Documentation"
			linkHref="/explorer"
			linkTitle="API Explorer"
		/>
		<DocsLayout>
			<h2 className="text-4xl mb-2">Post Controller</h2>
			List of routes to get <b>Post</b> data.

			<RoutesList routes={POST_ROUTES} />
		</DocsLayout>
	</React.Fragment>
);

